import React from "react";
import "./App.css";
import HomePage from "./pages/home";
import { Routes, Route } from "react-router-dom";
import CartPage from "./pages/cart";
import ProductDetailsPage from "./pages/productDetails";
import ProductsPage from "./pages/products";
import CheckoutPage from "./pages/checkout";
import OrderSuccessPage from "./pages/success";
import AboutPage from "./pages/about-us";
import MetaPixelTracker from "./utils/metainit";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <div className="App">
      <MetaPixelTracker />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/product/:slug" element={<ProductDetailsPage />} />
        <Route path="/order/success" element={<OrderSuccessPage />} />
        <Route path="/about-us" element={<AboutPage />} />
        <Route
          path="*"
          element={
            <div className="p-12 text-center text-3xl font-black">
              404 Not Found
            </div>
          }
        />
      </Routes>
      <Toaster />
    </div>
  );
}

export default App;
